import * as Yup from 'yup';

const SubstitutionWordSchema = Yup.object().shape({
  word: Yup.string().required('Substitution word is required'),
  variants: Yup.string().required('Please enter comma separated variants for the Substitution word'),
});

export default SubstitutionWordSchema;